import { render, staticRenderFns } from "./PatientStoryForm.vue?vue&type=template&id=b2244cc0&scoped=true"
import script from "./PatientStoryForm.vue?vue&type=script&lang=js"
export * from "./PatientStoryForm.vue?vue&type=script&lang=js"
import style0 from "./PatientStoryForm.vue?vue&type=style&index=0&id=b2244cc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2244cc0",
  null
  
)

export default component.exports